// usage:
// create a new LoadingAnimation-Object with a parameter selector (string).
// selector has to be the class of the depending html-tag which needs to be triggered.
// the HTML-Tag needs the class "hide", "loadingAnimation".
// example: <div class="loadingAnimation hide"></div>

export class LoadingAnimation {
  private readonly hideClass: string = 'hide';
  private readonly selector: string = '';
  private readonly loadingAnimationElement;

  constructor(selector: string) {
    this.selector = selector;
    this.loadingAnimationElement = document.querySelector(this.selector);
    if (this.loadingAnimationElement !== null) {
      this.createLoadingDots();
    }
  }

  public showLoadingAnimation () {
    this.loadingAnimationElement.classList.remove(this.hideClass);
  }

  public hideLoadingAnimation () {
    this.loadingAnimationElement.classList.add(this.hideClass);
  }

  private createLoadingDots () {
    for (let i = 1; i < 9; i++) {
      let dot = document.createElement('div');
      dot.classList.add('loadingAnimationDot', 'loadingAnimationDot--' + i);
      this.loadingAnimationElement.appendChild(dot);
    }
  }
}
